import "./PercentageBar.less";
import { I18nComponent } from "react/utils/I18nComponent";

export function PercentageBar({ percentage }: { percentage: number }) {
    const value = percentage.toFixed(0);
    return (
        <div
            className="PercentageBarClass gux-label"
            data-testid="percentage-bar"
        >
            <I18nComponent
                i18nKey="PercentageBar.Value"
                substitutions={{
                    value,
                    PercentageBar: (
                        <div className="visualization">
                            <div style={{ width: `${value}%` }} />
                        </div>
                    ),
                }}
            />
        </div>
    );
}
